module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('p', {
    staticClass: "chapter-title2"
  }, [_c('b', [_vm._v("CONTENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/preface"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/preface1"
    }
  }, [_vm._v("Preface to the Second Edition")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/chap1"
    }
  }, [_vm._v("1 Island Tourism")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2 Work and Encounters in Tourism")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3 The Airport")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chap3#ch3-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Redcap | "), _c('i', [_vm._v("Wendy Husbands")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chap3#ch3-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Teller and Money Exchanger | "), _c('i', [_vm._v("Joyann Springer")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4 The Hotel")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chap4#ch4-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Taxi Driver | "), _c('i', [_vm._v("Trevor Mapp")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chap4#ch4-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bartender | "), _c('i', [_vm._v("Sylvan Alleyne")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chap4#ch4-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Guest Services Director | "), _c('i', [_vm._v("Marilyn Cooper")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chap4#ch4-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Room Attendant (Maid) | "), _c('i', [_vm._v("Sheralyn O'Neale")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chap4#ch4-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Security | "), _c('i', [_vm._v("Errol Sobers")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chap4#ch4-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chef | "), _c('i', [_vm._v("Malcolm Bovell")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chap4#ch4-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Manager | "), _c('i', [_vm._v("Martin Barrow")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5 The Beach")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chap5#ch5-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Beach Vendor | "), _c('i', [_vm._v("Rosco Roach")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chap5#ch5-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hotel Water Sports | "), _c('i', [_vm._v("Zerphyl Greaves")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chap5#ch5-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jet-Ski Operator | "), _c('i', [_vm._v("Ricky Hinds")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chap5#ch5-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dive Shop | "), _c('i', [_vm._v("Brian Rock")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6 The Attractions")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chap6#ch6-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cruise-Ship Shore Excursions | "), _c('i', [_vm._v("Rosie Hartmann")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chap6#ch6-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Island Bus Tours | "), _c('i', [_vm._v("Anderson Hughes")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chap6#ch6-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Co-Pilot, Atlantis Submarines | "), _c('i', [_vm._v("Michael Walcott")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chap6#ch6-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tour Guide, Harrison's Cave | "), _c('i', [_vm._v("Malika Marshall")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chap6#ch6-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Captain, Jolly Roger Pirate Cruises | "), _c('i', [_vm._v("Dwayne Parry")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chap6#ch6-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Owner-Operator, Cycling Tours | "), _c('i', [_vm._v("Robert Quintyne")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7 The Research and Promotion of Tourism")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chap7#ch7-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Barbados Hotel and Tourism Association | "), _c('i', [_vm._v("Colin Jordan")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chap7#ch7-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chief Research Officer, Ministry of Tourism | "), _c('i', [_vm._v("Everton Gill")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8 Conclusion")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/epi",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epilogue: Student Encounters with Tourists and Tourism")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/acknowledgment",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/acksecondedition",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments for the Second Edition")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/bibilography",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/index",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-78a90703","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/toc.vue
// module id = 66
// module chunks = 0